"use strict";

import React, {Component} from "react";
import PropTypes from "prop-types";

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class InfoBox extends Component {

    static defaultProps = {
        iconBgColor: "black",
    };

    static propTypes = {
        icon: PropTypes.string.isRequired,
        iconBgColor: PropTypes.string,
        header: PropTypes.oneOfType([
                       PropTypes.arrayOf(PropTypes.node),
                       PropTypes.node
                   ]),
        content: PropTypes.oneOfType([
                       PropTypes.arrayOf(PropTypes.node),
                       PropTypes.node
                   ]),
    };

    constructor(props) {
        super(props);
    }

    render() {
        const { iconBgColor, icon, header, content } = this.props;
        return (
            <div className="info-box">
                <span className={`info-box-icon bg-${iconBgColor}`}>
                    <FontAwesomeIcon icon={icon} />
                </span>

                <div className="info-box-content">
                    <span className="info-box-text">
                        {header}
                    </span>
                    <span className="info-box-number">
                        {content}
                    </span>
                </div>
            </div>
        );
    }

}

export default InfoBox;